import { BaseUserQueue } from '../base-user-queue';
import { ToastService } from '@hss-m/uikit-common';
import { Component, ViewChild, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StylistsService } from '../../stylists.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppService } from 'src/app/shared/services/app.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ViewTablePage } from 'src/app/shared/modules/data-view-table/view-table.service';
import { AdditionalInfoModalComponent } from '../../overview/modal/additional-info/additional-info.component';
import { USER_QUEUES_FILTERS, getDataTableColumnConfig, getContextMenuConfigForIndividualQueue } from '../config.const';
import { DataViewTableConfig, ViewTableComponent } from 'src/app/shared/modules/data-view-table/view-table/view-table.component';

@Component({
  selector: 'app-single-user-queues',
  templateUrl: '../all-users-queues/all-users-queues.component.html',
  styleUrls: ['../all-users-queues/all-users-queues.component.scss']
})
export class SingleUserQueuesComponent extends BaseUserQueue implements OnInit {
 
  @ViewChild(ViewTableComponent) viewTableComponent: ViewTableComponent;

  user: any;
  config: DataViewTableConfig = {
    url: 'stylist/users/all-queues',
    dataKey: 'queues',
    page: new ViewTablePage(),
    columns: getDataTableColumnConfig(this).filter(col => !['UID', 'Name'].includes(col.name)),
    selection: true,
    noContentMessage: 'No Queues found',
    contextMenuConfig: getContextMenuConfigForIndividualQueue(this),
    tableId: 'qatch.columns./stylists/all-queues/person',
    onDataLoad: this.getNameOfSelectedUser.bind(this)
  };

  filterId = 'single-users-queues';
  showBreadcrumb = false;
  breadcrumbItems = [{'label': 'Queues'}, {'label': 'Single User Queues'}]

  constructor(
    protected override deviceService: DeviceDetectorService,
    protected override readonly stylistsService: StylistsService,
    protected route: ActivatedRoute,
    protected override router: Router,
    protected override authService: AuthService,
    private appService: AppService,
    protected override toastService: ToastService,
    protected override modalService: NgbModal
  ) {
    super(stylistsService, router, deviceService, authService, toastService, modalService);
    this.queuesForSingleUser = true;
    this.filters = JSON.parse(JSON.stringify(USER_QUEUES_FILTERS));
    this.route.params.subscribe((params: any) => {
      this.config.url = `stylist/users/${params['id']}/all-queues`
      this.config.page.pageNumber = 0;
      this.selectedUsers.push({ uid: params['id'] });
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override postFirebaseAuth() {
    super.onInit();
  }

  getViewTableComponent(): ViewTableComponent {
    return this.viewTableComponent;
  }

  getNameOfSelectedUser(rows){
    this.user = rows[0];
    this.selectedUserName = `${this.user.uid} - ${this.user.first_name || ''} ${this.user.last_name || ''}`;
    this.appService.setTitle(this.selectedUserName);
  }

  showAdditionalInfo(user: any){
    const modalRef = this.modalService.open(AdditionalInfoModalComponent, { centered: true, size: 'lg', windowClass: 'app-stylists-detail' });
    modalRef.componentInstance.user = this.user;
    modalRef.result.then((result) => {
      if(result === true) {
      }
    },(reason) => {});
  }
}
